import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const SuccessPopup = ({ isOpen, toggle, onConfirm, message }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered>
    <ModalHeader toggle={toggle}  className="text-success">Success</ModalHeader>
    <ModalBody>
      {message || 'Operation completed successfully!'}
    </ModalBody>
    <ModalFooter>
      <Button color="success" onClick={onConfirm}>Okay</Button>
      {/* <Button color="secondary" onClick={toggle}>Close</Button> */}
    </ModalFooter>
  </Modal>
);

export default SuccessPopup;
